/**
 *
 * @author Nandhini Narasimhan @ 02/05/2018 12:36
 * @description
 * @notes
 */
import React, {Component} from "react"
import styled from "styled-components"
import {get} from "lodash"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {Card} from "@irati/ui/src/Layout"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {injectRouteWithQuery} from "@irati/utils/helpers/routing"
import padding from "@irati/ui/src/global/padding"
import {AnalysisContext} from "@irati/insights/context"
import {minWidthMedia} from "@irati/ui/src/global/media"
import HasPermissionTo from "@irati/utils/permissions/HasPermissionTo"

import {Comments} from "../Comments"
import ScoreCard from "./ScoreCard"
import {Questions} from "./"
import sitemap from "../../routes/sitemap"
import {Heatmap} from "../Heatmap"


const SpacedCard = styled(Card)`
  margin-bottom: ${padding.medium};
  padding: 0;
`

const SpacedSection = styled.div`
  margin-bottom: ${padding.medium};
`

const ActionList = styled.div`
  display: flex;
  justify-content: flex-end;

  > * {
    flex: 1;
  }

 ${minWidthMedia.desktop`
    > * {
      flex: inherit;
    }
 `}
`


class Analysis extends Component {
  render() {
    const idNamespace = id("Analysis", this.props)

    return (
      <AnalysisContext.Consumer>
        {({schedule, filters}) => {
          const driverCount = get(schedule, "drivers.results.length")
          const includeDriverComment = get(schedule, "preferences.includeDriverComment")
          return (
            <>
              <SpacedSection>
                <ActionList>
                  <ButtonRouterLink
                    primary
                    to={injectRouteWithQuery(sitemap.reports.path, {
                      queryParams: {...filters, scheduleId: schedule.id}
                    })}>
                    <FormattedMessage id="insights.analysis.actions.reports.cta" />
                  </ButtonRouterLink>
                </ActionList>
              </SpacedSection>

              <SpacedSection>
                <SpacedCard>
                  <ScoreCard id={idNamespace} />
                </SpacedCard>
              </SpacedSection>

              {driverCount > 1 && (
                <SpacedSection>
                  <HasPermissionTo
                    Error={null}
                    permissions={["insights.heatmap"]}>
                    <Heatmap id={idNamespace} schedule={schedule} />
                  </HasPermissionTo>
                </SpacedSection>
              )}

              <SpacedSection>
                <Questions id={idNamespace} />
              </SpacedSection>

              {includeDriverComment && (
                <SpacedSection>
                  <Comments
                    id={idNamespace}
                    schedule={schedule}
                    filters={filters} />
                </SpacedSection>
              )}
            </>
          )
        }}
      </AnalysisContext.Consumer>
    )
  }
}

export default Analysis
